import CourseSyllabusSection from '../sections/CourseSyllabusSection';
import LearningResultSection from '../sections/LearningResultSection';
import LearningUnitSection from '../sections/LearningUnitSection';

const CourseTeachingTab = () => {
  return (
    <>
      <CourseSyllabusSection />
      <LearningUnitSection />
      <LearningResultSection />
    </>
  );
};

export default CourseTeachingTab;
